import 'remotes/@designTokens/efr';
import { render } from '@modern-js/runtime/browser';
import { createRoot } from '@modern-js/runtime/react';
import { initTheme } from '@packages/common/utils/initTheme';
import { serviceWorkerHandler } from '@packages/common/utils/serviceWorkerHandler/serviceWorkerHandler';
import { AnimatePresence } from 'motion/react';
import { appDataStore } from 'store/AppDataStore/AppDataStore';

const ModernRoot = createRoot();

async function beforeRender() {
	initTheme();
	await serviceWorkerHandler.init();
	serviceWorkerHandler.setNetworkStatus(window.navigator.onLine);
	window.addEventListener('offline', networkOfflineHandler);
	window.addEventListener('online', networkOnlineHandler);
	await appDataStore.init();
}

beforeRender().then(() => {
	render(
		<AnimatePresence>
			<ModernRoot />
		</AnimatePresence>,
		'app',
	).then();
});

function networkOfflineHandler() {
	serviceWorkerHandler.setNetworkStatus(false);
}
function networkOnlineHandler() {
	serviceWorkerHandler.setNetworkStatus(true);
}
